import { useDispatch, useSelector } from 'umi';
import { FILTER_EXTEND_NAMESPACE } from '@/pages/intelligence/models/filterExtend';

interface UseFilterExtendOptions {
  pageId?: string;
}

export default function useFilterExtend(props: UseFilterExtendOptions = {}) {
  const { pageId } = props || {};
  const dispatch = useDispatch();
  const {
    isOperate,
    isOperateByPage,
    topchartFilterExtendCommon,
    topchartFilterExtendByPage,
    isOperateDetail,
    isOperateRegion,
    detailFilterExtendCommon,
  } = useSelector((state) => {
    // @ts-ignore
    const {
      isOperate,
      isOperateByPage,
      topchartFilterExtendCommon,
      topchartFilterExtendByPage,
      isOperateDetail,
      isOperateRegion,
      detailFilterExtendCommon,
    } = state[FILTER_EXTEND_NAMESPACE];
    return {
      isOperate,
      isOperateByPage,
      topchartFilterExtendCommon,
      topchartFilterExtendByPage,
      isOperateDetail,
      isOperateRegion,
      detailFilterExtendCommon,
    };
  });

  const currentOperate = pageId ? Boolean(isOperateByPage?.[pageId]) : isOperate;
  const currentFilterExtend = pageId
    ? topchartFilterExtendByPage?.[pageId]
    : topchartFilterExtendCommon;

  const setFilterExtendFun = (
    value: any,
    filterExtendCommon: any,
    dispatchType: string,
    options?: { operateFlag?: boolean; pageKey?: string },
  ) => {
    const { operateFlag, pageKey } = options || {};
    const shouldMerge =
      typeof operateFlag === 'boolean'
        ? operateFlag
        : pageKey
        ? false
        : isOperate;
    const newVal = value || {};

    if (pageKey) {
      dispatch({
        type: dispatchType,
        payload: {
          pageId: pageKey,
          value: newVal,
          merge: shouldMerge,
        },
      });
      return;
    }

    dispatch({
      type: dispatchType,
      payload: shouldMerge
        ? {
            ...(filterExtendCommon || {}),
            ...newVal,
          }
        : newVal,
    });
  };

  const resetFilterExtendFun = (
    value: any,
    dispatchType: string,
    options?: { pageKey?: string },
  ) => {
    const { pageKey } = options || {};
    if (pageKey) {
      dispatch({
        type: dispatchType,
        payload: {
          pageId: pageKey,
          value: null,
        },
      });
      return;
    }

    dispatch({
      type: dispatchType,
      payload: null,
    });
  };

  /** 修改榜单继承：榜单继承同时继承详情 */
  const setTopchartFilterExtendFun = (value: any) => {
    setFilterExtendFun(
      value,
      currentFilterExtend,
      pageId
        ? `${FILTER_EXTEND_NAMESPACE}/saveTopchartFilterExtendByPage`
        : `${FILTER_EXTEND_NAMESPACE}/saveTopchartFilterExtendCommon`,
      {
        operateFlag: pageId ? currentOperate : isOperate,
        pageKey: pageId,
      },
    );

    if (pageId) {
      dispatch({
        type: `${FILTER_EXTEND_NAMESPACE}/saveIsOperateByPage`,
        payload: { pageId, value: true },
      });
    } else {
      dispatch({
        type: `${FILTER_EXTEND_NAMESPACE}/saveIsOperate`,
        payload: true,
      });
    }
  };

  // 设置详情页继承
  const setDetailFilterExtendFun = (value: any) => {
    setFilterExtendFun(
      value,
      detailFilterExtendCommon,
      `${FILTER_EXTEND_NAMESPACE}/saveDetailFilterExtendCommon`,
      { operateFlag: Boolean(isOperateDetail) },
    );
    dispatch({
      type: `${FILTER_EXTEND_NAMESPACE}/saveIsOperateDetail`,
      payload: true,
    });
  };

  /** 修改榜单继承：清除榜单继承同时清除详情 */
  const resetTopchartFilterExtendFun = (value: any) => {
    resetFilterExtendFun(
      value,
      pageId
        ? `${FILTER_EXTEND_NAMESPACE}/saveTopchartFilterExtendByPage`
        : `${FILTER_EXTEND_NAMESPACE}/saveTopchartFilterExtendCommon`,
      { pageKey: pageId },
    );

    if (pageId) {
      dispatch({
        type: `${FILTER_EXTEND_NAMESPACE}/saveIsOperateByPage`,
        payload: { pageId, value: false },
      });
    } else {
      dispatch({
        type: `${FILTER_EXTEND_NAMESPACE}/saveIsOperate`,
        payload: false,
      });
    }
    dispatch({
      type: `${FILTER_EXTEND_NAMESPACE}/saveIsOperateRegion`,
      payload: false,
    });
  };

  // 清除详情页继承
  const resetDetailFilterExtendFun = (value: any) => {
    resetFilterExtendFun(
      value,
      `${FILTER_EXTEND_NAMESPACE}/saveDetailFilterExtendCommon`,
    );
    dispatch({
      type: `${FILTER_EXTEND_NAMESPACE}/saveIsOperateDetail`,
      payload: false,
    });
    dispatch({
      type: `${FILTER_EXTEND_NAMESPACE}/saveIsOperateRegion`,
      payload: false,
    });
  };

  const modelValueName = () => {
    return {
      filterExtend: currentOperate ? currentFilterExtend : null,
      detailFilterExtend: isOperateDetail ? detailFilterExtendCommon : null,
      setFilterExtend: (value: any) => {
        setTopchartFilterExtendFun(value);
        setDetailFilterExtendFun(value);
      },
      resetFilterExtend: (value?: any) => {
        resetTopchartFilterExtendFun(value), resetDetailFilterExtendFun(value);
      },
      setDetailFilterExtend: (value: any) => setDetailFilterExtendFun(value),
      resetDetailFilterExtend: (value?: any) => resetDetailFilterExtendFun(value),
    };
  };

  const {
    filterExtend,
    detailFilterExtend,
    setFilterExtend,
    resetFilterExtend,
    setDetailFilterExtend,
    resetDetailFilterExtend,
  } = modelValueName();

  return {
    isOperate: !!currentOperate,
    // 榜单页继承
    filterExtend,
    setFilterExtend,
    resetFilterExtend,
    // 详情页的继承
    isOperateDetail,
    isOperateRegion,
    detailFilterExtend,
    setDetailFilterExtend,
    resetDetailFilterExtend,
  };
}
